document.addEventListener('DOMContentLoaded', function () {
  const toggleButton = document.getElementById('toggle-sort-button');
  const sortDiv = document.getElementById('facet-sort-mobile');
  const overlay = sortDiv.querySelector('.overlay'); // Target overlay inside sortDiv
  const sortOptions = sortDiv.querySelector('.facet-filters__sort-options');
  const facetForm = document.getElementById('FacetFiltersForm'); // Get the main form

  // 1. Logic to open/close the modal
  overlay.addEventListener('click', function () {
    sortDiv.classList.remove('_active');
  });

  toggleButton.addEventListener('click', function () {
    sortDiv.classList.toggle('_active');
  });

  // 2. ⭐ NEW LOGIC TO HANDLE SORT SELECTION AND FORM SUBMISSION ⭐
  if (sortOptions && facetForm) {
    sortOptions.addEventListener('change', function(event) {
      const radioInput = event.target;

      // Check if the changed element is one of the sort radio buttons
      if (radioInput.matches('input[name="sort_by"][type="radio"]')) {
        
        // A. Update the hidden sort input in the main form (important for desktop/filter context)
        const mainSortInput = facetForm.querySelector('input[name="sort_by"]');
        if (mainSortInput) {
          mainSortInput.value = radioInput.value;
        }

        // B. Close the mobile sort modal
        sortDiv.classList.remove('_active');
        
        // C. Trigger the form submission/filtering logic
        // This is the core fix. It should either submit the form (reloading the page)
        // or trigger the theme's AJAX filtering logic.
        
        // Option 1: Simple form submit (reloads the page, common for initial fix)
        facetForm.submit(); 

        // Option 2: If your theme uses a custom element for filtering, you might need to dispatch an event:
        // const facetFiltersFormElement = document.querySelector('facet-filters-form');
        // facetFiltersFormElement.onSortChange(); // Assuming your theme has a method like this

        // If your theme uses an AJAX custom element (like 'facet-filters-form'), 
        // a simple form submission often triggers the custom element's intercept logic.
      }
    });
  }
});